export default __webpack_public_path__ + "static/media/low-battery.c4b80f38.png";